import * as betprofessor from './Navigation.styles.betprofessor';
import * as betroyale from './Navigation.styles.betroyale';
import * as fiestabet from './Navigation.styles.fiestabet';
import * as goldenrush from './Navigation.styles.goldenrush';
import * as juicybet from './Navigation.styles.juicybet';
import * as puntcity from './Navigation.styles.puntcity';
import * as puntgenie from './Navigation.styles.puntgenie';
import * as sterlingparker from './Navigation.styles.sterlingparker';
import * as vikingbet from './Navigation.styles.vikingbet';
import * as volcanobet from './Navigation.styles.volcanobet';
import * as forsport from './Navigation.styles.forsport';
import * as junglebet from './Navigation.styles.junglebet';
import * as betstride from './Navigation.styles.betstride';
import * as sugarcastle from './Navigation.styles.sugarcastle';
import * as oldgill from './Navigation.styles.oldgill';
import * as buffalobet from './Navigation.styles.buffalobet';
import * as titanbet from './Navigation.styles.titanbet';
import * as templebet from './Navigation.styles.templebet';
import * as bet777 from './Navigation.styles.bet777';
import * as goldenbet888 from './Navigation.styles.goldenbet888';
import * as gigabet from './Navigation.styles.gigabet';
import * as slambet from './Navigation.styles.slambet';
import * as hyperbet from './Navigation.styles.hyperbet';
import * as chromabet from './Navigation.styles.chromabet';
import * as questbet from './Navigation.styles.questbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  templebet,
  bet777,
  goldenbet888,
  gigabet,
  slambet,
  betstride,
  hyperbet,
  chromabet,
  questbet,
};
